import { Component, computed, inject, input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { IFiltersConfig } from '@nha/components/filters/interfaces';
import { NHASelectorComponent } from '../selector/selector.component';
import { NHATestDirective } from '../../../../directives/test/test.directive';
import { FilterStateService } from '../../state/filter-state.service';

@Component({
	selector: 'nha-selectors',
	templateUrl: './selectors.component.html',
	styleUrls: ['./selectors.component.scss'],
	encapsulation: ViewEncapsulation.None,
	imports: [NHATestDirective, NHASelectorComponent]
})
export class NHASelectorsComponent implements OnInit, OnDestroy {
	private readonly filterState = inject(FilterStateService);

	key = input<string>();
	config = input<IFiltersConfig>();
	skipSetup = input<boolean>(false);
	initializeFilters = input<boolean>(true);

	visibleSelectors = computed(() => this.filterState.getVisibleSelectors(this.key())());
	loaded = computed(() => this.filterState.getLoaded(this.key())());

	constructor() {}

	ngOnInit(): void {
		const key = this.key();
		const config = this.config();

		if (!key || !config) {
			return;
		}

		if (!this.skipSetup()) {
			this.filterState.addFilterInstance(key, config, this.initializeFilters());
		}
	}

	ngOnDestroy(): void {
		const key = this.key();
		if (key) {
			this.filterState.deInitializeFilter(key);
		}
	}
}
